<template>
  <div
    class="text-center"
    style="min-width: 100%"
  >
    <v-dialog
      v-model="dialog"
    >
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          large
          block
        >
          Payments Made
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Payments Made
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="payments"
            :items-per-page="10"
            class="elevation-1"
          >
            <template #body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  :class="defineBackground(item)"
                >
                  <td>
                    <v-icon v-if="item.child">
                      mdi-history
                    </v-icon>
                    <v-icon v-if="item.parent && !item.child">
                      mdi-arrow-right-circle
                    </v-icon>
                    {{ item.info }}
                  </td>
                  <td>{{ item.amount }}</td>
                  <td>{{ item.payment_type.title }}</td>
                  <td>{{ item.additional_info?.tranPrincipal ?? '0.00' }}</td>
                  <td>{{ item.additional_info?.tranInterest ?? '0.00' }}</td>
                  <td>{{ getPaymentStatus(item) }}</td>
                  <td>{{ formatDate(item.apply_date) }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { DateTime } from 'luxon';

export default {
  name: 'PaymentsMade',
  props: {
    loanId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      paymentSchedules: [],
      headers: [
        { title: 'Info', key: 'info' },
        { title: 'Amount', key: 'amount' },
        { title: 'Type', key: 'type' },
        { title: 'Principal', key: 'principal' },
        { title: 'Interest', key: 'interest' },
        { title: 'Status', key: 'status' },
        { title: 'Apply Date', key: 'created' },
      ],
    };
  },
  computed: {
    ...mapState('loanProLoan', ['payments']),
  },
  methods: {
    defineBackground(item) {
      return {
        backgroundRed: item.status !== 'payment.status.success' && item.status !== 'payment.status.none',
        backgroundLightRed: item.status === 'payment.status.voided',
        backgroundTan: item.child !== null,
      };
    },
    getPaymentStatus(item) {
      const reverseReason = item.nacha_return_code ? ` - ${item.nacha_return_code.split('-')[0]}` : '';
      switch (item.status) {
        case ('payment.status.success'):
          return 'Success';
        case ('payment.status.none'):
          return 'Pending';
        case ('payment.status.voided'):
          return `Reverse${reverseReason}`;
        default:
          return 'Failed';
      }
    },
    getLastValue(item, value) {
      return item[value]?.split(/[\s.]+/)?.pop() || '';
    },
    formatDate(date) {
      return DateTime.fromSQL(date).toLocaleString(DateTime.DATE_SHORT);
    },
  },
};
</script>

<style scoped>
  .backgroundRed {
    background-color: rgba(230, 10, 10, 0.7);
    color: white;
  }
  .backgroundLightRed {
    background-color: rgba(252, 133, 133, 0.42) !important;
    color: white !important;
  }
  .backgroundTan {
    background-color: rgb(237, 229, 218) !important;
    color: white !important;
    padding-left: 30px !important;
  }
</style>
